import { Card, Row, Col } from "react-bootstrap";
import React from "react";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import InputComponent from "../UI/InputComponent/InputComponent";

const OsobeSearch = (props) => {
  return (
    <>
      <Card className="search_card">
        <Card.Body>
          <Card.Title>Pretraga</Card.Title>
          <InputComponent
            onChange={(e) => props.onSearchChanged(e)}
            onKeyPress={(e) => props.onEnterPressed(e)}
            id="imePrezime"
            controlLabel={"Unesite prezime ili registarski broj"}
          />
          <Row>
            <Col>
              <ButtonComponent
                onClick={props.onSearchSubmitted()}
                variant="primary"
              >
                Pretraga
              </ButtonComponent>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default OsobeSearch;
